import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { KomitentTelefon } from './komitent-telefon';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-komitent-telefon-modal-update',
  templateUrl: './komitent-telefon-modal-update.component.html'
})
export class KomitentTelefonModalUpdateComponent extends BaseModalUpdateComponent<KomitentTelefon> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<KomitentTelefon>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
